import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, BoxProps } from '@mui/material';
import useTenantTheme from 'src/careflow/ph-core/multi-tenant/tenant/hook/useTenantTheme';
// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export default function Logo({ disabledLink = false, sx }: Props) {
  const { logo, tenantName } = useTenantTheme();
  const alt = tenantName ? `${tenantName} logo` : 'Logo';
  const logoSrc = logo ? logo : 'logo/my_care_circle_horizontal_logo.png';

  const component = (
    <Box>
      <img src={logoSrc} style={{ width: 150 }} alt={alt} />
    </Box>
  );

  if (disabledLink) {
    return <>{component}</>;
  }

  return <RouterLink to="/">{component}</RouterLink>;
}
